<template>
  <div id="content" class="linkplusGenerator">

    <SendByEmail :dialogVisible='dialog.email' @close="dialog.email=false" @newValueIsProposed="sendByEmail($event)" ></SendByEmail>
    <AddToListModal  :dialogVisible='dialog.list'  @close="dialog.list = false" @toExisting="toExisting($event)"></AddToListModal>
    <DetailAssessment @close="detailAssessment=false" :startup="detailsForCandidate" :dialogVisible="detailAssessment">  </DetailAssessment>
    <ConfirmModal :dialogVisible='dialogRemove' @close="dialogRemove = false" @confirmed="removeStartup($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>

    <StartupRunAssessment @close="runassessment=false" :dialogVisible="runassessment" @newInternal="newInternal"  @newInnopearl="newInnopearl" @existingInternal="existingInternal">
    </StartupRunAssessment>
    <div class="container" v-if="myLinkPlus">
      <div class="messagepromopubContainerBandeau">
        <div class="messagepromopub">
          Broaden innovation reach
          <a href="https://outlook.office365.com/book/innopearl@innopearl.ch/" target="_blank" class="bluehover"><strong>Leverage our scouting expertise</strong></a>
        </div>
      </div>
            <div class="linkplusContent">
              <div class="row">
              <div class="mt50">
                  <div class="linkPlusUs">
                    <h2 class="tblue fs24">My scouting campaign links </h2>
                    <div class="row mt20 flexItCenter">
                        <div class="col-12 col-lg-6 col-xl-4">

                          <div class="beautiful_qrcode_file" >
                              <div class="loader"  v-if="!myLinkPlus.access_id"></div>
                              <img :src="bqr" v-if="bqr" alt="" class="w100 ">

                          </div>
                        </div>
                          <div class="col-12 col-lg-6 col-xl-8 flexGapCol">
                            <div class="ins">

                              <!-- <img :src="require('@/assets/images/web.svg')" alt="" class="pictoForm tblue"> -->
                              <span class="zone_input_name tblue">Copy Link+</span>
                              <div class="field has-addons mt10">
                                   <div id="copyToClipboardContent" class="control" style="width:100%">
                                     <input ref="generator" class="generator" v-model="myLinkPlus.link" type="text" readonly >
                                   </div>
                                   <a id="copyToClipboard" v-on:click.prevent="copyToClipboard" class="button control is-medium">
                                     <span class="icon">
                                       <v-icon icon="mdi:mdi-content-copy" style="font-size: 18px;"/>
                                     </span>
                                   </a>
                                 </div>
                            </div>

                            <div class="ins">
                              <!-- <img :src="require('@/assets/images/calendar.svg')" alt="" class="pictoForm tblue"> -->
                                <span class="zone_input_name tblue">Expiration date</span>
                              <div class="field has-addons mt10">
                                <input type="date" ref="expirationD" autocomplete="off" placeholder="dd-mm-yyyy"  :class="hasValue ? 'date' : 'date noValue'" v-model="expirationDateFormated">

                                <div id="falseCalendar" class="button control is-medium" @click="$refs.expirationD.focus();$refs.expirationD.click();$refs.expirationD.showPicker();">
                                  <span class="icon">
                                    <v-icon icon="mdi:mdi-calendar" style="font-size: 18px;"/>
                                  </span>
                                </div>

                                </div>
                            </div>

                          </div>
                    </div>
                    <div class="row mt20 ">
                      <div class="text-right flexMobile" v-if='myLinkPlus.access_id'>
                        <button @click="dialog.email = true" class="prev_step_btn btn" >Send by mail</button>
                        <a :href="this.apiUrl+'/beautiful_qrcode_file/'+myLinkPlus.access_id.$oid"  class="btn next_step_btn">Download QR Code</a>

                      </div>
                  </div>
                  <div class=" mt20 text-left">
                    Use Link+ to engage innovators at events, through your network, or on your website.
                    <br/>
                    <strong>At events:</strong> add it to your phone and scouting campaigns, or share it with colleagues.<br/>
                    <strong>On your website:</strong> simply copy the URL and send it to your web provider, or contact Innopearl for support.
                  </div>
                  </div>
              </div>

              <div class="col-12 mt50">
                  <h2 class="tblue fs24">Update your landing page</h2>
              </div>
              <div class="col-12 col-lg-6 col-xl-4 mt20">
                <div class="zone_input">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Campaign name</span>
                  </div>
                  <input type="text"  maxLength="30" class="innopearl_input" v-model="myLinkPlus.name">
                </div>
                <div class="zone_input mt20" v-if="myLinkPlus.project">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Linked to project</span>
                  </div>
                  <select class="innopearl_input">
                    <option >{{myLinkPlus.project.name}}</option>
                  </select>


                </div>



                <div class="zone_input mt20">
                  <div class="zone_input_header">
                    <span class="zone_input_name">Open to</span>
                  </div>
                  <div class="custom-toggle mt20">
                 <button
                   :class="{'active': myLinkPlus.open_to === 'startups'}"
                   @click="myLinkPlus.open_to = 'startups'"
                 >
                   Only startups
                 </button>
                 <button
                   :class="{'active': myLinkPlus.open_to === 'other'}"
                   @click="myLinkPlus.open_to = 'other'"
                 >
                   Any organization
                 </button>
               </div>
                </div>
                <div class="zone_input mt20">
                  <div class="zone_input_header">
                    <span class="zone_input_name tblue">Image banner</span>
                  </div>
                  <small>Recommended size: 1600x500 px</small>
                  <div class="mylink_banner" >
                     <img :src="this.apiUrl+'/get_image/'+smyLinkPlus_image+'?token='+$store.state.innotoken" alt="" class="forceSize" v-if="myLinkPlus.image">
                     <div class="changeImage">
                        <button type="button" name="button" @click='dialog.image = true'>+ CHANGE IMAGE</button>
                        <ImageChange :dialogVisible='dialog.image' @close="dialog.image=false" @newValueIsProposed="imageChangeVal($event)" ></ImageChange>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-12 col-lg-6 col-xl-8 mt20">
                <div class="zone_input">
                      <div class="zone_input_header">
                          <span class="zone_input_name">Description</span>
                      </div>
                      <small style='width:100%;display:block;margin-top:10px;'>Share your needs and attract innovators, or apply the template set up by your admin</small>

                      <div class="mt20">
                        <QuillEditor ref="linkplusContentEditor"  theme="snow" v-model="content" :content="content" contentType="delta" :toolbar="toolbarOptions" />

                      </div>
                </div>
                <div class="zone_input mt50">
                      <div class="zone_input_header">
                          <span class="zone_input_name">Terms and conditions</span>


                      </div>
                      <small>Show the Terms and Conditions that apply to applicant participation on your landing page</small>
                      <div class="mt20">
                        <label for="disableFeedBackCheckbox" class="selectIt forceWidth300" >
                          <input class="customizeCheckbox" type="checkbox" v-model="myLinkPlus.show_terms" id="disableFeedBackCheckbox" >
                          <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>
                          <span>{{ $t("Show the Terms and Conditions")}}</span>
                        </label>
                      </div>

                      <div class="mt20" v-if="myLinkPlus.show_terms">
                        <!-- <QuillEditor ref="linkplusTermsAndConditionEditor"  theme="snow" v-model="terms_and_conditions" :content="terms_and_conditions" contentType="delta" :toolbar="toolbarOptions" /> -->
                        <textarea name="name" rows="8" cols="80" v-model="myLinkPlus.terms_and_conditions" placeholder="Terms and Conditions are managed and set by your team’s administrator. Please reach out to your admin for more details or updates"></textarea>
                      </div>
                </div>
              </div>
              <div class="row mt20 ">
                <div class="text-right flexMobile">
                  <a :href="myLinkPlus.link" class="prev_step_btn btn" target="_blank">Preview</a>
                  <button type="button" class="btn next_step_btn" name="button" @click="generateLinkplus">Update</button>

                </div>
            </div>
            </div>



            </div>

            <div id="submitedStartup">


            <div class="linkplusContent"  v-if="myLinkPlus.pool.length > 0">

      <div class="row" id="">
        <div class="col-12 mt50">
          <h2 class="tdoree">Submitted innovator profiles</h2>


          <div class="row zone">

           <div class="new_action_zone ">


           <div class="super_action_zone lplus" v-if="startups_quicksearch.length > 0">

               <div class="quicksearch">
                     <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
               </div>
               <div class="btnszone">
                 <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                   <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogRemove = true" :disabled="are_selected.length == 0">Remove</button>
                   <span class="whyDisabled">
                     <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                   </span>
                 </div>
                 <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                   <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="runassessment = true"  :disabled="are_selected.length == 0">{{$t("Add to assessment")}}</button>
                   <span class="whyDisabled">
                     <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                   </span>
                 </div>
                 <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                   <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialog.list = true" :disabled="are_selected.length == 0">Add to a list</button>
                   <span class="whyDisabled">
                     <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                   </span>
                 </div>
               </div>

             </div>
           </div>
            <div class="col-12 zone_startups">
              <div class="row">
                <span class="numberOfStartupResult">
                  <strong>{{startups_quicksearch.length}}</strong> innovator<span v-if="startups_quicksearch.length > 1">s</span>
                </span>
              </div>
              <div class="row" v-if="startups_quicksearch.length > 0">
                <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in startups_quicksearch" :key="c">
                  <div class="candidate_card" :class="[(are_selected.includes(candidate._id.$oid)) ? 'isChecked' : 'notChecked' , candidate.isAssess ? 'isAssess' : 'notAssess']">
                    <div class="candidate_card_head">
                      <span class="name">{{candidate.name}}</span>
                      <div class="goRight">
                        <img :src="require('@/assets/inAnAssess.svg')" @click="showCandidateAssessment(candidate)" alt="" v-if="candidate.assessments.length > 0">

                        <div class="selectIt">
                          <input class="checkbox__input" type="checkbox" v-model="are_selected" :value="candidate._id.$oid"/>
                          <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                            <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                            <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                          </svg>
                        </div>
                      </div>

                    </div>
                    <div class="candidate_info_content">
                      <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate"/>
                      <NonStartupCardInner v-else :candidate="candidate"/>


                    </div>
                      <div class="website" v-if="candidate.website">
                         <a :href="getHttpsUrl(candidate.website)" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                      </div>
                    <div class="footer">

                      <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf"  v-if="candidate._id" class="detail">
                      Details
                      </router-link>
                    </div>


                        </div>
                </div>
              </div>
              <div v-else>
                <div class="alert alert-warning mt20">
                    No innovators
                </div>
              </div>
            </div>
          </div>
      </div>
      </div>

    </div>
                </div>
    </div>

  </div>
</template>
<script>

  import { toast } from 'vue-sonner'
 import api from '../tools/api';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ImageChange from '@/components/modals/imageChange.vue'
import SendByEmail from '@/components/modals/sendByEmail.vue'
import StartupCardInner from '@/components/StartupCardInner.vue'
import NonStartupCardInner from '@/components/NonStartupCardInner.vue'



 import AddToListModal from '@/components/modals/addToListAlt.vue'
 import StartupRunAssessment from '@/components/StartupRunAssessment.vue'
 import Quill from 'quill';
  import DetailAssessment from '@/components/DetailAssessment.vue'
  import ConfirmModal from '@/components/modals/ConfirmModal.vue';

 // Add fonts to whitelist
 const Font = Quill.import('formats/font');
 Font.whitelist = ['OpenSans', 'Roboto', 'Lato', 'Montserrat', 'SourceSansPro', 'Poppins', 'Raleway', 'Ubuntu', 'Oswald',"Merriweather"];
 Quill.register(Font, true);
//  Open Sans
// ·  Roboto
// ·  Lato
// ·  Montserrat
// ·  Source Sans Pro
// ·  Poppins
// ·  Raleway
// ·  Ubuntu
// ·  Oswald
// ·  Merriweather

export default {
  components: {
    QuillEditor,
    ImageChange,
    ConfirmModal,
    SendByEmail,
    StartupCardInner,
    NonStartupCardInner,
    AddToListModal,
    StartupRunAssessment,
    DetailAssessment

  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "Manage my Link+",
        subTitle : "",
      },
      dialogRemove:false,
      expirationDateFormated:null,
      quicksearch:"",
      startups_quicksearch:[],
      are_selected : [],
      dialog:{
        image:false,
        email: false,
        list:false,
      },
      detailsForCandidate:null,
      detailAssessment:false,
            runassessment:false,
      toolbarOptions : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'header': [1, 2, 3, false] }],
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': Font.whitelist }],
        ['clean']                                         // remove formatting button
      ],
      contentHTML:"",
      content:"Exemple",
      terms_and_conditions:"",
      myLinkPlus : {
        name: "My Link+ name",
        link : null,
        image:null,
        qrcode : null,
        content: '<h2><strong>COMPANY</strong></h2><p>A short description of your company and team. May be fill from Admin account information</p><br><h2><strong>CHALLENGE</strong></h2><p>A brief description of your business challenge and needs</p><br/><h2><strong>HOW IT WORKS </strong></h2><p>A brief description of what you offer and your selection process</p>',
        status : "DRAFT",
        pool: []
      }
    }
  },
  methods:{
    fillFromProject(){
      if(this.myLinkPlus.project.$oid){
        api.get(process.env.VUE_APP_API_URL+"/restrict/linkplus_desc_from_p/"+this.myLinkPlus.project.$oid,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( (r) => {
          console.log(r.data);
                  this.$refs.linkplusContentEditor.setHTML(r.data);
        });


      }
    },
    removeStartup(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/remove_startup_from_pool",
            {
              candidates : this.are_selected,
              linkplus : this.$route.params.lid
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("innovators successfully removed from this Link+.");
            api.get(process.env.VUE_APP_API_URL+"/restrict/linkplusbyid/"+this.$route.params.lid).then( (r) => {
              // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
               console.log(r);
              // var temp = _.merge(this.candidatespool, r.data)

              this.myLinkPlus = r.data;
              this.pageInfo.subTitle = this.myLinkPlus.name;
              this.$refs.linkplusContentEditor.setHTML(this.myLinkPlus.content);
              this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
              this.startups_quicksearch = this.myLinkPlus.pool;
              if(this.myLinkPlus.expirationDate){

                this.expirationDateFormated = this.myLinkPlus.expirationDate.date.split(' ')[0];
              }

              this.bqr = this.apiUrl+'/beautiful_qrcode_file/'+this.myLinkPlus.access_id.$oid+'?timestamp=' + new Date().getTime();


              console.log(r);
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
          }).catch( () => {
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

        this.dialogRemove =false;
    },
    showCandidateAssessment(c){
      this.detailsForCandidate = c;
      this.detailAssessment = true;
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    newInternal(v){
      console.log("newInternal",v);
      var toPost = {
        assessment : v,
        startups : this.are_selected
      }
      api.post(process.env.VUE_APP_API_URL+"/restrict/createAssessmentFromPool",toPost,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success(this.$t("Innovators are included in the assessment"));
          this.runassessment = false;
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.runassessment = false;
      });
    },
    newInnopearl(v){
    console.log(v);
    api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/generate_new_assessment/"+v._id.$oid,
      {
          candidates: this.are_selected
      },
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r.data);
      toast.success("New assessment have been asked to Innopearl Team");
          this.runassessment = false;
    }).catch( (e) => {
      console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });

    },
    existingInternal(v){
    console.log("existingInternal",v);
    var toPost = {
    assessment : v,
    startups : this.are_selected
    }
    api.post(process.env.VUE_APP_API_URL+"/restrict/addMultipleStartupsToAssessment",toPost,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
      toast.success(this.$t("Innovators are included in the assessment"));
      this.runassessment = false;
    }).catch( (e) => {
    console.log(e);
      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

    this.runassessment = false;
    });
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },
    getHttpsUrl(url){
      var f = url;
      if (!url.startsWith("https://")  && !url.startsWith("htts://") ) {
                  f = "https://" + url;
              }
              return f;
    },
    imageChangeVal(val){
      console.log(val);
      if(val){
        this.myLinkPlus.image = val;
        this.dialog.image = false;
      }
    },
    isValid(){
      return true;

    },
    toExisting(v){
      api.post(process.env.VUE_APP_API_URL+"/restrict/add_startup_to_list_multiple",
          {
            poolids : v,
            candidates : this.are_selected,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("Innovators successfully added to list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.dialog.list =false;
    },
    sendByEmail(v){

        var postdata = {
          recipient : v,
          linkplus : this.$route.params.lid
        }
        api.post(process.env.VUE_APP_API_URL+"/restrict/sendbyemail_linkplus",postdata,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( (r) => {
          console.log(r);

          toast.success("Mail sent ");
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      this.dialog.email = false;


    },
    copyToClipboard() {
      this.$refs.generator.focus();
      console.log(this.$refs.generator);
      navigator.clipboard.writeText(this.myLinkPlus.link)
      toast.success("Copied!");
    },
    downloadFile(url, fileName) {
            // Create a new XMLHttpRequest object
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';

            // Handle the onload event
            xhr.onload = function() {
                if (xhr.status === 200) {
                    // Create a blob object from the response
                    var blob = new Blob([xhr.response], { type: 'application/octet-stream' });

                    // Create a temporary URL for the blob
                    var blobUrl = window.URL.createObjectURL(blob);

                    // Create a temporary anchor element
                    var link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = fileName;

                    // Trigger a click event on the anchor element
                    link.click();

                    // Clean up the blob URL
                    window.URL.revokeObjectURL(blobUrl);
                }
            };

            // Send the XMLHttpRequest
            xhr.send();
        },
        reloadLinkPlus(){

          api.get(process.env.VUE_APP_API_URL+"/restrict/linkplusbyid_v2/"+this.$route.params.lid).then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)

            this.myLinkPlus = r.data;
            this.pageInfo.subTitle = this.myLinkPlus.name;
            this.$refs.linkplusContentEditor.setHTML(this.myLinkPlus.content);
            this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
            if(this.myLinkPlus.expirationDate){

              this.expirationDateFormated = this.myLinkPlus.expirationDate.date.split(' ')[0];
            }

            this.bqr = this.apiUrl+'/beautiful_qrcode_file/'+this.myLinkPlus.access_id.$oid+'?timestamp=' + new Date().getTime();
            console.log(r);
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        },
    generateLinkplus(){
      if(this.isValid()){
      //  toast.promise(() => new Promise((resolve,reject) => {

          this.myLinkPlus.newExpirationDate = this.expirationDateFormated;
          this.myLinkPlus.contenthtml = this.$refs.linkplusContentEditor.getHTML();
              console.log(this.myLinkPlus);
          this.startups_quicksearch = this.myLinkPlus.pool;
          api.post(process.env.VUE_APP_API_URL+"/restrict/update_linkplus_v2",this.myLinkPlus,{
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then( (r) => {
            console.log(r);
            this.reloadLinkPlus();
            this.$store.commit('UPDATE_LINKSPLUS',this.myLinkPlus)
            toast.success("Your Landing Page has been successfully updated.");
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });

      }

    },


  },
  computed:{
    smyLinkPlus_image: function(){
      if(this.myLinkPlus.image){
        console.log(this.myLinkPlus.image);
        return this.myLinkPlus.image.$oid;
      }
      else{
        return null;
      }

    },
    hasValue() {
      return (this.expirationDateFormated != '' && this.expirationDateFormated != null);
    }
  },
  watch:{
    quicksearch: function(v){
      console.log(v);
        this.startups_quicksearch = this.myLinkPlus.pool.filter(obj =>
       obj.name.toLowerCase().includes(v.toLowerCase())
     );
   },
 },
    mounted(){
      //if route params then load content
      api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
        this.projects = r.data;
        console.log(r.data);
        console.log(r);
      }).catch( (e) => console.log(e));
      api.get(process.env.VUE_APP_API_URL+"/restrict/linkplusbyid_v2/"+this.$route.params.lid).then( (r) => {
        // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
         console.log(r);
        // var temp = _.merge(this.candidatespool, r.data)

        this.myLinkPlus = r.data;
        this.pageInfo.subTitle = this.myLinkPlus.name;
        this.$refs.linkplusContentEditor.setHTML(this.myLinkPlus.content);
        this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
        this.startups_quicksearch = this.myLinkPlus.pool;
        if(this.myLinkPlus.expirationDate){

          this.expirationDateFormated = this.myLinkPlus.expirationDate.date.split(' ')[0];
        }

        this.bqr = this.apiUrl+'/beautiful_qrcode_file/'+this.myLinkPlus.access_id.$oid+'?timestamp=' + new Date().getTime();


        console.log(r);
      }).catch( (e) => {
        console.log(e);
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
     },
}
</script>
<style scoped >

@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Oswald:wght@200..700&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap');




.beautiful_qrcode_file .loader{
  width:300px !important;
  height:420px;
  max-width:90% !important;
  background:#EEE;
}
.beautiful_qrcode_file img{
  width:300px !important;
  max-width:90% !important;
}
.linkplusGenerator{
  padding-top:50px;
  padding-bottom: 50px;
}
.linkplusContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
padding-top: 0px;
margin-top:50px;
margin-bottom: 50px;

}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.prev_step_btn,
.prev_step_btn:hover{
  background: #FFF 0% 0% no-repeat padding-box;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}

.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
  position:relative;
}
.mt20{
  margin-top: 20px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:20px;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}
.mt10{
  margin-top:10px;
}
.fs18rem{
  font-size:1.8rem !important;
}
textarea{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100%);
margin-bottom: 20px;
padding: 5px;
 resize: none;
}

.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;

}
.mylink_banner{
  margin-top: 20px;
  position:relative;
  height:300px;
  background:#EFEFEF;
  padding: 0 !important;
}
.mylink_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.w200{
  width:200px !important;
}

.next_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  background:#3783C5;
  color:#FFF;
    margin:5px;
    text-decoration: none;
      display: inline-block;
}

.has-addons{
  display: flex;
  gap: 0;
  border: 1px solid #CCC;
  border-radius: 20px;
  width: 500px;
  max-width: 100%;
  position:relative;
}

#copyToClipboard{
  border-left : 1px solid #ccc;
  color: #000;
  padding: 10px 20px;
  border-radius: 0px 20px 20px 0px;
    cursor:pointer;
}
#copyToClipboardContent{
padding: 10px;
cursor:pointer;

}
input.date{
  padding: 10px;
  width:100%;
  border:none !important;
}

#copyToClipboardContent input{
  width: 100%;
  display: block;
  cursor:pointer;
  border:none !important;
  padding:0px;
}

.generator:focus{
   outline: none;
}
.mt50{
  margin-top:50px;
}

.linkplusContent{
  margin-top:0px;
}
.tooltip-text {
  display:none;
  position: absolute;
  z-index: 1;
  width: 100%;
  color: #000;
  font-size: 13px;
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px 15px 20px 15px;
box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
 .tooltip-text:hover,
.explanation_needed_icon:hover ~ .tooltip-text {
  display:block;
  bottom: 0px;
    left: 0;
    transform: translateY(100%);
}
.explanation_needed_icon{
  width:16px;
}


.messagepromopubContainer{
  display:flex;
  justify-content: flex-end;
  width:100%;
  margin-bottom:10px;
  text-align:center;
}
@media screen and (max-width:990px){
  .messagepromopubContainer{
    display:flex;
    justify-content: center;
      margin-bottom:20px;
  }
}
    .bluehover{
      color:inherit;
    }
    .bluehover:hover{
      color:#3783C5;
    }
.pictoForm{
  width:25px;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:25px;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}



.startup_selection_section{
  position:relative;
  padding-top:50px;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}

.pad-50{
  padding-left:50px;
  padding-right:50px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}


.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}
.flexItCenter{
  display:flex;
  justify-content: center;
  align-items: center;
}

.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}


.all_candidates_download_zone .title{

  font-size: 20px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
font-weight:500;
cursor : pointer;
}


.all_candidates_download_zone .description{
  display:block;
  margin-bottom: 20px;
  width:100%;
}
.all_candidates_download_zone a{
  color:#B38D2F !important;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}
img.goFullWhite{
filter: brightness(0) invert(1);
}

.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.mb10{
  margin-bottom:10px;
}
.mt20{
  margin-top:20px;
}

.tblack{
  color:#000;
}
.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}

.candidate_card_head .name{
  flex:1;
}
.score {
  height: 70px;
  width: 70px;
  -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  text-align: center;
  background: #B38D2F;
  color: white;
  font-size:17px;
}
.flexGapCol{
  display:flex;
  flex-direction: column;
  gap:50px;
}
.score::before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}


.nb_item{
  background: #B38D2F;
  padding: 2px 10px;
  border-radius: 5px;
  font-size: 10px;
  color:#FFF;
  vertical-align: middle;
  margin-right: 5px;
}
.dflex{
  display: flex;
  gap: 10px;
justify-content: stretch;
}

.checkbox{
  position:relative;
}
.checkbox_hover{
  background:#FFF;
  font-size:10px;
  display:none;
}

.checkboxItem:hover  .checkbox_hover{
  display:block;
}
.onecondition{
  width:100%;
  display:block;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}
.website a{
  color:#4c81c0 !important;
}
.showComments{
  cursor:pointer;
  position:relative;
}

.showComments img{
  width:30px;
}
.sidePannel{
  position: fixed;
  right: 0;
  width: min(100%,500px);
  background: #FFF;
  top: 0;
  height: 100vh;
  z-index: 999;
  overflow: scroll;

}

.oneFilter{
  padding-top: 20px;
  padding-bottom: 20px;
}
.oneFilter:not(:last-child){
border-bottom: 1px solid #ddd;
}
.oneFilter .filtreName{
  margin-bottom:10px;
  display:block;
  color:#4c81c0;
}
.oneFilter .value_possible{
  max-height:300px;
  overflow: scroll; /* Always show both horizontal and vertical scrollbar */
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #333 #fff; /* Firefox */
}

.oneFilter .value_possible::-webkit-scrollbar {
      width: 12px; /* Width of the scrollbar */
    }

.oneFilter .value_possible::-webkit-scrollbar-thumb {
      background-color: #333; /* Color of the thumb */
    }
.oneFilter .value_possible::-webkit-scrollbar-track {
      background-color: #fff; /* Color of the track */
    }

    .sidePannel .filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh - 100px);
    }

  .sidePannel .create_filters{
    overflow: scroll;
padding: 30px;
height: calc(100vh);
  }
    .footerPannel{
      position: static;
  height: 100px;
  border-top: 2px solid #4c81c0;
  padding:20px;
  text-align:right;
    }

      .footerPannel .btn{
      padding:5px 10px;
      background:#4c81c0;
      color:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }

    .footerPannel .btn_invert{
    padding:5px 10px;
    color:#4c81c0;
    background:#FFF;
    font-size:15px;
    border-radius: 20px;
    border:1px solid #4C81C0;
    margin:10px;
  }
  .triangle{
    width:15px;
  }

  .triangle.open{
    transform:rotate(180deg);
  }

  .candidate_card.isChecked{
    border-color:#4C81C0;
  }
  .candidate_card.isChecked .checkbox__icon .fond{
    fill:#FFF !important;
  }

  /* .candidate_card.isAssess{
    border-color:#ad8e41;
  } */
  /* .candidate_card.isAssess .candidate_card_head{
    background:#ad8e41;
  } */
.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.extraPoolsContainer{
  position:relative;
}
.extraPoolsIcons{
  width:20px;
}
.extraPoolsNumber{
  background: #B38D2F;
  color: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.isAssess .extraPoolsNumber{
  color: #B38D2F;
  background: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.nb_item_comments{
  background: #B38D2F;
  color: #FFF !important;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.new_action_zone {
  position: sticky;
    right: 0;
    top: 0;
    z-index:889;
    background:#FFF;
    padding-top:20px;
    padding-bottom: 20px;
}
.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 50px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 50px;
}

.zoneBtn{
  position:relative;
  display: flex;

}


.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
  z-index: 999;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.extraPoolsContainer:hover .hoverInfo{
  display:block;
}

.filter_content_title{
  text-transform:uppercase;
  font-weight:600;
}

.v-slider-track__background--opacity {
  opacity: 1;
}

.selectAll{
  border: 2px solid #4c81c0;
  padding: 10px 20px;
  border-radius: 50px;
  cursor: pointer;
}


[data-tooltip] {
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  position: relative;
  margin-right: auto;
}
[data-tooltip]::after {
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 0.3rem;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;
}
[data-tooltip].tooltip-top::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
  top: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-top::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}

.poolTitle .customH2{
  color:#B38D2F;
}

.poolTitle .customH2 .sfname{
  font-weight: 700;
  text-transform:uppercase;
}

/*

.quicksearch .input{
  max-width: 200px;
    border: 1px solid #fff;
    background: transparent;
    padding: 5px 20px;
    border-radius: 50px;
    outline: none;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
}


.quicksearch .input::-webkit-input-placeholder{
    color:#FFF;
}
.quicksearch .input:-moz-placeholder {
    color:#FFF;
} */

.quicksearch .input::-webkit-input-placeholder{
   color: #3783C5;
}
.quicksearch .input:-moz-placeholder {
 color: #3783C5;
}


.slider_mini_score{
  max-width: 350px;
  min-width: 300px;
}
@media screen and (max-width:990px){
  .quicksearch{
    max-width: 100%;
    width:100%;
    margin-top:20px;
  }
  .quicksearch .input{
    max-width: 100%;
    width:100%;
      background: transparent;
      padding: 5px 20px;
      border-radius: 50px;
      outline: none;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .filtre_list_2{
    width:100%;
    flex:1;
  }
}
.moneyEntryLine{
  width: 100%;

}
.moneyEntryName{
    color:#333;
}
.moneyEntryInput{
  flex:1;

}

.moneyEntryLine select{
  appearance: menulist;
  -moz-appearance: menulist;
  -webkit-appearance: menulist;
}

/* .ins{
  display:flex;
  gap:20px;
  width:100%;

} */

@supports (font: -apple-system-body) and (-webkit-appearance:none){
  input[type="date"].noValue{
    color: #000;
    position:relative;
  }
  input[type="date"].noValue:before{
    content :'dd/mm/YYYY';
    color:#333;
    display:inline-block;
    position:absolute;
  }
 input[type="date"].noValue::-webkit-datetime-edit {
    visibility: hidden;
  }
}

  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }

  .links_2{
    border-top: 1px solid #DDD;
  }
  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }
  .v-slider-track__background--opacity {
    opacity: 1;
  }

  .candidate{
    margin-top:20px;
    margin-bottom: 20px;
  }
  .candidate_card{
    border: 2px solid #DDDDDD;
  border-radius: 15px;
  z-index: 5;
  height:100%;
  display: flex;
  flex-direction: column;
  }
  .candidate_card .candidate_image{
    width:100%;
    height:200px;
    object-fit: cover;
    z-index: 1;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

.field_container .date{
  width: 500px;
  max-width: 100%;
  border-radius: 50px;
  border: 1px solid #CCC;
  border-radius: 20px;
  padding:10px;
}
  .clickable{
    cursor:pointer;
  }
  .candidate_card .candidate_links{
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px 5px;

    margin: 0;
  }
  .candidate_card .candidate_info_content .candidate_name{
    font-size:18px;
    line-height:21px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  display:block;
  font-weight: 500;
  }

  .candidate_card .candidate_info_content .candidate_desc{
    font-size:16px;
    line-height:22px;
    margin-top:10px;
    display:block;
    margin-bottom:10px;
  }
  .candidate_card .candidate_links .details{
    font-size:12px;
    line-height: 15px;
    border-right: 1px solid #DDD;
    display:flex;
    align-items: center;
    text-transform: uppercase;
    color: #3783C5;
    flex: 0.5;

  }
  .candidate_card .candidate_links .details a{
      text-decoration: none;
  }
  .candidate_card .candidate_links .details img{
    margin-right:5px;
  }
  .candidate_card .candidate_links .selectIt{
    font-size:12px;
    line-height: 15px;
    letter-spacing: 0px;
    color: #3783C5;
    text-transform: uppercase;
    flex:0.5;
    align-items: flex-end;

  }

  .candidate_card .candidate_links .selectIt_fw{
    flex:1;
    align-items: flex-start;
  }
  .candidate_card .candidate_links .selectIt_fw label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: start;
  }
  .candidate_card .candidate_links .selectIt label{
  display:flex;
  align-items: center;
  gap: 5px;
  justify-content: end;
  }
  .candidate_card .candidate_links .selectIt input{
    width:24px;
    height:24px;
  }
  .candidate_card .candidate_links .details.noBorder{
    border-right: none;

  }
  .checkbox {
    cursor: pointer;
    display: flex;
    align-items: center;
    /* margin-bottom:20px; */
  }
  .checkboxItem{
    margin-bottom: 20px;
  }
  .checkbox__input {
    position: absolute;
    width: 1.375em;
    height: 1.375em;
    opacity: 0;
    cursor: pointer;
  }
  .checkbox__input:checked + .checkbox__icon .tick {
    stroke-dashoffset: 0;
  }
  .checkbox__icon {
    width: 1.375em;
    height: 1.375em;
    flex-shrink: 0;
    overflow: visible;
  }
  .checkbox__icon .tick {
    stroke-dasharray: 20px;
    stroke-dashoffset: 20px;
    transition: stroke-dashoffset 0.2s ease-out;
  }
  .checkbox__label {
    margin-left: 0.5em;
  }
.tupper{
  text-transform: uppercase;
}
.tblue{
  color:#4C81C0;
}

/* .linkPlusUs{
  border:1px solid #CCC;
  padding:20px 50px;
} */
.linkPlusUs{
  padding-bottom:50px;
  border-bottom : 1px solid #CCC;
}
@media screen and (max-width:780px){
  .flexMobile{
    display: flex;
  flex-direction: column;
  }
  .ins{
    display: flex;
  flex-direction: column;

  }
  .linkPlusUs{
    padding:20px;
  }
}
@media screen and (max-width:990px){
  .beautiful_qrcode_file{
    text-align:center !important;
  }
}

.fs24{
  font-size:24px;
}

.customh2{
  color: #3783c5;
  font-size: 21px;
  text-transform: uppercase;
  margin-bottom: 20px;

}
#falseCalendar{
  border-left: 1px solid #ccc;
  color: #000;
  padding: 10px 20px;
  border-radius: 0px 20px 20px 0px;
  cursor: pointer;
  position: absolute;
  right: 0;
  background: #FFF;
}
.tdoree{
  color:#B38D2F;
}
.numberRes{
  font-weight: 400;
  color:#3783c5;
}

@media screen and (min-width:1301px) and (max-width:1650px){
  .candidate {
    flex: 0 0 auto;
    width: calc(100% / 3);
  }

}
@media screen and (min-width:1000px) and (max-width:1300px){
  .candidate {
    flex: 0 0 auto;
    width: 50%;
  }

}
input:focus,
input:focus-visible{
  outline: none;
  box-shadow: none;
  border:none;
}



  .quicksearch{
    position:relative;
  }
  .quicksearch .input{
    max-width:300px;
      border: 1px solid #3783C5;
      background: transparent;
      padding: 10px 20px;
      padding-right: 50px;
      border-radius: 50px;
      outline: none;
      color: #3783C5;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .quicksearch::after{
    content: url('@/assets/loupe.svg');
    position:absolute;
    right:15px;
    top:50%;
    transform:translateY(-50%);
  }

  .quicksearch .input::-webkit-input-placeholder{
      color:#FFF;
  }
  .quicksearch .input:-moz-placeholder {
      color:#FFF;
  }

  .super_action_zone{
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;
    background: rgba(55, 131, 197, .07);
  border-radius: 50px;
  margin-right: 20px;
  margin-left: 20px;
  display:flex;
  align-items: center;
  justify-content: space-between;
  }




  @media screen and (max-width:690px){
      .super_action_zone{flex-direction: column;gap:20px;    padding: 10px;}
    .quicksearch{
      margin-top:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;

    }
    .filtre_list_2{
      width:100%;
      flex:1;
    }
  }
    .tooglerFilter .toogler{
      color:#3982C4;
      font-weight: 400px;
      display:flex;
      gap:10px;
    }


    .numberOfStartupResult{
      text-align:center;
    font-size: 21px;
    line-height:25px ;
letter-spacing: 0px;
color: rgba(55, 131, 197, 1);
text-transform: uppercase;
margin-top:25px;
    }

    .flexItCenterButtons{
      width:100%;
      display:flex;
      justify-content: center;
      align-items: center;
      gap:10px;
      margin-top:20px;    flex-wrap: wrap;
    }


    .action_btn_pool,
    .action_btn_pool:hover{
      background: rgba(55, 131, 197, 1);
      border:1px solid rgba(55, 131, 197, 1);
      color: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 50px;
      text-transform: uppercase;
      font-size:15px;
    }

    .disabledRlink{
      pointer-events: none;
      opacity: 0.7;
    }
    .selectAll{
      color: rgba(179, 141, 47, 1);
      border:1px solid rgba(179, 141, 47, 1);
      background: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 50px;
      text-transform: uppercase;
      font-size:15px;
    }


    .zoneBtn{
      position:relative;
      display: flex;
    width:auto;

    }

    .candidate_card.isChecked{
      border-color:#4C81C0;
    }
    .candidate_card.isChecked .checkbox__icon .fond{
      fill:transparent !important;
    }
    .candidate_card:not(.whitehead).isChecked .checkbox__icon .tick{
      stroke:#FFF !important;
    }

    .detail{
      background: #F1F6FB;
  padding: 10px 20px;
  border-radius: 50px;
  text-align: center;
    }
.btnszone{
  display:flex;
  gap:20px;
}
.messagepromopubContainerBandeau{
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 0px;
  text-align: center;
  background: #1368b2;
  color: #FFF;
  padding: 12px;
}
.messagepromopubContainerBandeau a:hover{
  color:inherit !important;
}
.row.text-center{
display:block;
}

.toggle-wrapper {
  margin: 20px 0;
}

.toggle-label {
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}

.required {
  color: red;
}

.custom-toggle {
  display: flex;
  border: 1px solid #1368b2;
  border-radius: 999px;
  overflow: hidden;
  width: fit-content;
}

.custom-toggle button {
  background: transparent;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  color: #1368b2;
  transition: background 0.3s;
}

.custom-toggle button.active {
  background-color: #1368b2;
  color: #fff;
}



    .selectIt{


    display:flex;
    align-items: center;
    gap: 5px;
    }

      input[type="checkbox"].customizeCheckbox{
        display:none;
      }
      .custom-checkbox img{
            display:none;
            position: absolute;
      top: 3px;
      left: 3px;
      width:12px;
      }

      .custom-checkbox {
          width: 20px; /* Circle diameter */
          height: 20px; /* Circle diameter */
          border: 2px solid #5081C1; /* Light gray border for unselected state */
          border-radius: 0%; /* Make it a circle */
          transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
      }


      input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox {
          border-color: #5081C1; /* Change border color when selected */
          background:#5081C1;
          position:relative;
      }
      input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox > img{
          display:block;
      }

@media screen and (max-width:890px){
  .super_action_zone.lplus .btnszone{
    flex-direction:column;
    align-items:center;
  }
}

@media screen and (max-width:1600px){
  .super_action_zone.lplus{
    flex-direction: column;
gap: 20px;
flex-wrap: nowrap;
  }
  .super_action_zone.lplus .quicksearch input{
    max-width: 100% !important;
    width:100%;
  }
}

</style>
<style media="screen">
.ql-editor{
  min-height:300px;
  font-family: 'Montserrat' !important;
}
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value]::before {
    content: attr(data-value) !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Roboto"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Roboto"]::before {
    font-family: 'Roboto' !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="OpenSans"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="OpenSans"]::before {
    font-family: 'Open Sans' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Lato"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Lato"]::before {
    font-family: 'Lato' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Montserrat"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Montserrat"]::before {
    font-family: 'Montserrat' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SourceSansPro"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SourceSansPro"]::before {
    font-family: 'Source Code Pro' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Poppins"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Poppins"]::before {
    font-family: 'Poppins' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Raleway"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Raleway"]::before {
    font-family: 'Raleway' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Ubuntu"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Ubuntu"]::before {
    font-family: 'Ubuntu' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Oswald"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Oswald"]::before {
    font-family: 'Oswald' !important;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Merriweather"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Merriweather"]::before {
    font-family: 'Merriweather' !important;
  }

.ql-font-Oswald{
      font-family: 'Oswald' !important;
}
.ql-font-Merriweather{
      font-family: 'Merriweather' !important;
}
.ql-font-Ubuntu{
        font-family: 'Ubuntu' !important;
}
.ql-font-Raleway{
        font-family: 'Raleway' !important;
}
.ql-font-Poppins{
        font-family: 'Poppins' !important;
}
.ql-font-Montserrat{
        font-family: 'Montserrat' !important;
}
.ql-font-Lato{
        font-family: 'Lato' !important;
}
.ql-font-Oswald{
        font-family: 'Oswald' !important;
}

.ql-font-OpenSans{
        font-family: 'Open Sans' !important;
}

.ql-font-SourceSansPro{
    font-family: 'Source Code Pro' !important;
}

  .ql-snow .ql-picker.ql-font {
    width: 150px !important;
    white-space: nowrap;
  }

  .ql-container{
    font-size:14px !important;
  }
</style>
